import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'cc_theme_mode';

function getInitialMode() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  // The UI is designed light-first (aaPanel-style); only honour an explicit
  // opt-in via the header toggle, not the OS dark-mode preference.
  return 'light';
}

const initialState = {
  themeMode: getInitialMode(),
  sidebarOpen: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleThemeMode(state) {
      state.themeMode = state.themeMode === 'dark' ? 'light' : 'dark';
      localStorage.setItem(STORAGE_KEY, state.themeMode);
    },
    setThemeMode(state, action) {
      state.themeMode = action.payload;
      localStorage.setItem(STORAGE_KEY, state.themeMode);
    },
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
  },
});

export const { toggleThemeMode, setThemeMode, toggleSidebar } = uiSlice.actions;
export default uiSlice.reducer;
